import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { NetworkErrors } from 'context';
import { PATHS } from 'router/config';
import { isLmsAccessSuspendedNow } from 'core/hooks/Users/isLmsAccessSuspendedNow';

export const useGoToErrorPage = () => {
  const navigate = useNavigate();

  const goToErrorPage = useCallback(
    (error?: NetworkErrors) => {
      // ТЗ 0074: ошибка страницы у приостановленного студента — это
      // LMS_ACCESS_SUSPENDED, а не сбой. Гард маршрутов уведёт на /invoices и
      // сам, но эффект ошибки страницы может сработать РАНЬШЕ гарда — тогда
      // студент застрял бы на /error.
      if (isLmsAccessSuspendedNow()) {
        navigate(PATHS.invoices, { replace: true });
        return;
      }
      navigate(`/${error || NetworkErrors.otherError}`, { replace: true });
    },
    [navigate],
  );

  return goToErrorPage;
};
